<p-tabs value="information">
  <p-tablist>
    <p-tab value="information">
      {{ 'common.navigation.information.title' | translateSafe }}
    </p-tab>

    <p-tab value="alarmRule">
      {{ 'common.navigation.alarm-rule.title' | translateSafe }}
    </p-tab>

  </p-tablist>

  <p-tabpanels>
    <p-tabpanel class="information" value="information">
      <div class="form-content">
        <div class="h3 title">
          <span class="material-symbols-rounded">devices</span>
          {{ 'common.fields.device' | translateSafe }}
        </div>

        <div class="row">
          <app-input-text [formData]="serialNumberConfig"
                          [isLoading]="loading"/>
          <app-input-text [formData]="deviceEUIConfig"
                          [isLoading]="loading"/>
        </div>

        <div class="row">
          <app-input-text [formData]="lastSigiSendTimeConfig"
                          [isLoading]="loading"/>
        </div>

        <hr class="break-line">

        <div class="h3 title">
          <span class="material-symbols-rounded">map</span>
          {{ 'common.fields.address' | translateSafe }}
        </div>

        <div class="row-address">
          <app-input-text [formData]="addressConfig"
                          [isLoading]="loading || requestCoords"/>
          <app-button-icon (click)="openCoordsSelectionMap()"
                           iconName="location_on"/>
        </div>

        <div class="row">
          <app-input-text [formData]="latitudeConfig"
                          [isLoading]="loading || requestCoords"/>
          <app-input-text [formData]="longitudeConfig"
                          [isLoading]="loading || requestCoords"/>
        </div>

        <div class="row">
          <app-input-date [formData]="installationDateConfig"
                          [isLoading]="loading"/>
          <app-dropdown-selector [formData]="installationDistrictConfig"
                                 [isLoading]="loading"/>
        </div>

        <hr class="break-line">

        <div class="h3 title">
          <span class="material-symbols-rounded">construction</span>
          {{ 'common.fields.metadata' | translateSafe }}
        </div>

        <div class="row">
          <app-input-select [formData]="deviceProfileConfig"
                            [isLoading]="loading"/>
          <app-input-select [formData]="deviceDecoderConfig"
                            [isLoading]="loading"/>
        </div>

        <app-input-textarea [formData]="commentsConfig"
                            [isLoading]="loading"/>

        <div class="row small">
          <app-input-select-button [formData]="deviceSizeSelectConfig"
                                   [isLoading]="loading"/>
          <app-input-select-button [formData]="deviceDNSelectConfig"
                                   [isLoading]="loading"/>
        </div>

        <app-input-select-button [formData]="deviceRotationSelectConfig"
                                 [isLoading]="loading"/>

        <div class="row">
          <app-input-select [formData]="devicePipeTypeDropdownConfig"
                            [isLoading]="loading"/>
          <app-dropdown-selector [formData]="deviceRoomDropdownConfig"
                                 [isLoading]="loading"/>
        </div>

        <app-image-edit-gallery #imageGallery
                                [formData]="imageConfig"/>

        @if (hasRole(AccountRole.SUPER_ADMIN)) {
          <app-input-submit (click)="updateMeasurements()"
                            [formData]="updateMeasurementConfig"/>
        }
      </div>

      <app-input-submit (click)="submitOnClick()"
                        [formData]="submitConfig"/>

    </p-tabpanel>

    <p-tabpanel value="alarmRule">
      <app-device-edit-alarm-rule [device]="device"/>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<app-dialog-base (click)="toggleSelectCoordsDialog()"
                 [buttonAction]="closeSelectCoordsDialog"
                 [class.open]="isSelectCoords"
                 [title]="'common.field.choose-coordinates' | translateSafe"
                 iconLeft="map">

  <app-dialog-map-coords-selector #dialogMapCoordsSelector
                                  (coordsSelected)="onCoordsSelected($event)"/>
</app-dialog-base>
